import React from 'react';
import '../ContactStyle/ContactMain.css';

const ContactMain = () => {
  return (
    <div className="about-container">
      <div className="contact-hero-shapes">
        <div className="contact-shape shape-1"></div>
        <div className="contact-shape shape-2"></div>
        <div className="contact-shape shape-3"></div>
      </div>
      <div className="about-content">
        <div className="text-container">
          <span className="contact-hero-badge">Get In Touch</span>
          <h1 className="main-heading">
            Welcome to <span className="contact-heading-accent">Bellary Info Tech Solutions</span>
          </h1>
          <p className="quote">
            "Empowering businesses through innovative technology and strategic solutions."
          </p>
          <div className="contact-hero-tags">
            <span><i className="bi bi-envelope"></i> Email Us</span>
            <span><i className="bi bi-telephone"></i> Call Us</span>
            <span><i className="bi bi-geo-alt"></i> Visit Us</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactMain;
